import Vue from 'vue'
import Router from 'vue-router'
import Home from "@/views/Main/Home";
import NotFoundPage from "@/views/Main/NotFoundPage";
import MethodsList from "@/views/Main/Methods/MethodsList";
import MethodsThemeList from "@/views/Main/Methods/MethodsThemeList";
import MethodView from "@/views/Main/Methods/MethodView";
import PreviewMethod from "./views/Main/Methods/PreviewMethod";
import AdminRoutes from '@/Routers/Admin/Main'

Vue.use(Router);

// const ifNotAuthenticated = (to, from, next) => {
//     if (!localStorage.getItem('AdminAuth')) {
//         next();
//         return;
//     }
//     next('/');
// };
//
// const ifAuthenticated = (to, from, next) => {
//     if (localStorage.getItem('AdminAuth')) {
//         next();
//         return
//     }
//     next('/admin_auth')
// };

export default new Router({
  routes: [
    ...AdminRoutes,
    // Main
    {
      path: '/',
      name: 'Home',
      meta: {layout: 'Main'},
      component: Home,
    },
    // Methods
    {
      path: '/methods',
      name: 'Methods',
      meta: {layout: 'Main'},
      component: MethodsList,
    },
    {
      path: '/methods/preview/:qtheme_id',
      name: 'PreviewMethod',
      props: true,
      meta: {layout: 'Main'},
      component: PreviewMethod,
    },
    {
      path: '/methods/:qtheme_id',
      name: 'MethodsTheme',
      props: true,
      meta: {layout: 'Main'},
      component: MethodsThemeList,
    },
    {
      path: '/methods/:theme_id/:method_id',
      name: 'MethodView',
      props: true,
      meta: {layout: 'Main'},
      component: MethodView,
    },


    // 404
    {
      path: '*',
      name: 'NotFoundPage',
      meta: {layout: 'Empty'},
      component: NotFoundPage,
    },
  ]
});
